"use client";

import CustomImage from '@/components/image';
import styles from './_completion-rates.module.scss';
import { useMemo } from 'react';
import PageAnchor from '@/components/page-anchor';

export default function HcpClinicalInformationCompletionRates({ index = 0 }) {
  const containerClass = useMemo(() => {
    let className = styles.container;

    className = `${className} ${styles['container_index' + index]}`;

    return className;
  }, [index])

  return (
    <section className={containerClass}>
      {index === 0 && <PageAnchor anchorId="trial-1-safety-completion-rates" instant />}
      {index === 1 && <PageAnchor anchorId="trial-2-safety-completion-rates" instant />}
      <div className="container">
        {index === 0 && <h2 className="page-heading h1">
          High completion rates for both trials
        </h2>}
        {index === 1 && <h2 className="page-heading h1 max-w-[700px] block mx-auto">
          High completion rates in both adults and children
        </h2>}
        <div className={styles.cards}>
          <div className={styles.cardContainer}>
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <h3 className={styles.trialTitle}>CAHtalyst<sup>&reg;</sup> Pediatric</h3>
                <CustomImage 
                  src="/images/page/hcp/clinical-information/Clinical-Information_Pediatric-Trial-Icon.svg" 
                  width={80} 
                  height={80} 
                  alt="" 
                  className={styles.icon}
                />
              </div>
              <div className={styles.percentage}>100%</div>
              <p className={styles.description}>
                of children treated with CRENESSITY completed the 28-week, phase 3 trial (N=69)<sup>3,9</sup>*
              </p>
              <ul className={styles.note}>
                <li><strong>82%</strong> of children remained in the open-label extension through 2 years (n=84/103)<sup>6</sup></li>
              </ul>
            </div>
          </div>

          <div className={styles.cardContainer}>
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <h3 className={styles.trialTitle}>CAHtalyst<sup>&reg;</sup> Adult</h3>
                <CustomImage 
                  src="/images/page/hcp/clinical-information/Clinical-Information_Adult-Trial-Icon.svg" 
                  width={80} 
                  height={80} 
                  alt="" 
                  className={`${styles.icon} ${styles.iconAdult}`}
                />
              </div>
              <div className={styles.percentage}>96%</div>
              <p className={styles.description}>
                of adults treated with CRENESSITY completed the 24-week, phase 3 trial (N=122)<sup>4,10&dagger;</sup>
              </p>
              <ul className={styles.note}>
                <li><strong>82%</strong> of adults remained in the open-label extension through 2 years (n=149/182)<sup>7</sup></li>
              </ul>
            </div>

          </div>
        </div>

        <div className='hcp-callout'>
          <p>Both during and after the double-blind phase, a total of 3% of patients taking CRENESSITY and no patients taking placebo discontinued due to an adverse reaction.<sup>1</sup></p>
          <p>One adult discontinued during the double-blind phase. <br/>Three additional adults and two children discontinued after the double-blind phase.<sup>9,10‡</sup></p>
        </div>

        <ul className='footnotes'>
          <li>
            <span className='hang'>*</span>
            <span>No patients discontinued due to an adverse reaction during the double-blind phase.<sup>9</sup></span>
          </li>
          <li>
            <sup className='hang'>†</sup>
            <span>One patient discontinued due to a gastric ulcer during the double-blind phase.<sup>8,10</sup></span>
          </li>
          <li>
            <sup className='hang'>‡</sup>
            <span>In addition to the 6 patients who discontinued due to an adverse reaction, 1 additional patient withdrew from CAHtalyst<sup>&reg;</sup> Pediatric. 1 adult experienced a related serious adverse reaction of worsening rash 2.5 months after discontinuation of CRENESSITY; this event was not counted among the treatment-emergent adverse events due to its latency.<sup>9,10</sup></span>
          </li>
        </ul>
      </div>
    </section>
  );
}
